import { useMemo, useEffect } from "react";
import debounce from "lodash.debounce";

// Хук, який створює debounced-версію колбеку
const useDebounce = (callback, delay) => {
  // Мемоізуємо debounced-функцію, щоб вона не створювалася заново при кожному ре-рендері
  const debouncedCallback = useMemo(() => debounce(callback, delay), [callback, delay]);

  // Очищуємо таймер при демонтуванні компонента, щоб уникнути викликів у неіснуючому компоненті.
  useEffect(() => {
    return () => {
      debouncedCallback.cancel();
    };
  }, [debouncedCallback]);

  return debouncedCallback;
};

export default useDebounce;
